import React from 'react';

import { Link } from 'gatsby';

import PostcardStar from '../../../../images/postcards-star.png';
import '../../../styles/common/promos/fundraiser-banner.scss';

const daysLeft = () => {
  const boundaryDate = new Date();
  boundaryDate.setUTCFullYear(2025);
  boundaryDate.setUTCMonth(5); // WARNING: Note zero-indexed month
  boundaryDate.setUTCDate(26); // Note add a day to the "natural" day because ends at midnight Pacific, so 8am GMT following day
  boundaryDate.setUTCHours(8);
  boundaryDate.setUTCMinutes(0);
  boundaryDate.setUTCSeconds(0);
  const today = new Date();

  const timeDifference = boundaryDate.getTime() - today.getTime();
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  if (daysDifference <= 0) {
    return `Very final day of our Fundraiser!`;
  } else if (daysDifference === 1) {
    return 'Just 1 day left of our Fundraiser';
  } else if (daysDifference < 8) {
    return `Just ${daysDifference} days left of our Fundraiser`;
  } else {
    return `Our Mid-Year Fundraiser is Launched`;
  }
};

const FundraiserBanner = (props) => (
  <>
    {(props.path.substr(0, 8) !== '/support') &&
      <div role="complementary" aria-label="Promotional Banner" className="sitewide-banner fundraiser-banner">
        <Link to="/support">
          <div className="contents narrow-page-width">
            <span className="left-side">
              <img src={ PostcardStar } alt="Postcards" />
            </span>
            <span className="details">
              <span className="headline">
                {daysLeft()}
              </span>
              <span className="subhead">
                We need your help to keep the project alive!
              </span>

              <span className="cta-button">
                Donate Today
              </span>

              <span className="footer">
                Perks include receiving twice-a-year our <span className="highlight">very special postcard packs</span>!<br />
                Next theme … “DESIRE”
              </span>
            </span>
            <span className="right-side">
              <img src={ PostcardStar } alt="Postcards" />
            </span>
          </div>
        </Link>
      </div>
    }
  </>
);

export default FundraiserBanner;
